import _ from 'lodash';
import PropTypes from 'prop-types';

import Image from '../shared/image.component';
import { FadeInAnimation } from '../shared';

// Component
const AboutSection = (props) => {

    const { imgSrc, imgAlt, title, icons } = props;

    const renderImageSection = () => (

        <Image className='about-section-image' src={imgSrc} alt={imgAlt} isOldImage />

    );

    const renderIcons = () => {

        if (!icons) return null;

        return icons.map((icon, index) => {

            const iconSrc = _.get(icon, 'icon_image.url');
            const iconTitle = _.get(icon, 'icon_title');
            const iconParagraph = _.get(icon, 'icon_paragraph');

            return (

                <FadeInAnimation key={index}>

                    <div className='about-section-icon-and-text-container'>

                        <div className='about-section-icon-container'>
                            <img className='about-section-icon-image' src={iconSrc} alt="" />
                        </div>

                        <div>
                            <h5>{iconTitle}</h5>
                            <p className='about-section-dark-text-opacity'>{iconParagraph}</p>
                        </div>

                    </div>

                </FadeInAnimation>
            );
        });
    };

    return (

        <div className='container-root container-root-maxWidthLg'>

            <FadeInAnimation>

                <div className='about-section-main-heading-container'>

                    <h2 className='about-section-main-heading'>{title}</h2>

                </div>

            </FadeInAnimation>

            <div className='main-grid-container about-section-grid-container'>

                <div className='main-grid-item main-grid-lg-6'>
                    {renderImageSection()}
                </div>

                <div className='main-grid-item main-grid-lg-5'>
                    {renderIcons()}
                </div>

            </div>

        </div>

    );
};

AboutSection.propTypes = {
    imgSrc: PropTypes.string,
    imgAlt: PropTypes.string,
    icons: PropTypes.array,
    title: PropTypes.string,
};

export default AboutSection;



